import React, { useState, useEffect } from 'react';
import api from '../../../api';
import DynamicBanner from '../include/DynamicBanner';
import './Care_Konnect.css'; 

const DocCard = ({ title, files, id, colorIndex }) => {
  const colorClass = colorIndex % 2 === 0 ? 'bg-primary-dark' : 'bg-primary-light';

  const getFullUrl = (path) => {
    if (!path) return "#";
    if (path.startsWith("http")) return path;

    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${process.env.REACT_APP_API_URL}/public${cleanPath}`;
  };

  return (
    <div className="col-lg-3 col-md-6">
      <div className="doc-card-approval">

        <div
          className={`card-header-custom ${colorClass}`}
          data-bs-toggle="collapse"
          data-bs-target={`#${id}`}
          data-bs-parent="#careKonnectAccordion"
          aria-expanded="false"
          aria-controls={id}
          style={{ cursor: "pointer" }}
        >
          <span className="truncate-text-approval">{title}</span>
          <i className="fa fa-chevron-down arrow-icon"></i>
        </div>

        <div id={id} className="collapse" data-bs-parent="#careKonnectAccordion">
          <div className="card-body-custom">
            {files?.length > 0 ? (
              files.map((file, index) => (
                <a
                  key={index}
                  href={getFullUrl(file)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="doc-link-approval"
                >
                  <span className="doc-link-approval-text">
                    View Document {files.length > 1 ? `(${index + 1})` : ""}
                  </span>
                  <i className="fa fa-file-pdf-o external-icon"></i>
                </a>
              ))
            ) : (
              <div className="doc-link-approval text-muted">
                <small>No documents available</small>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

const CareKonnect = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  const formatBannerPath = (path) => {
    if (!path) return null;
    return `/${path.replace(/^\//, "")}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/api/sitepages/academic/care-konnect');

        if (response.data?.status) {
          const data = response.data.data;

          const processedBanner = {
            ...data.banner,
            desktop_images: data.banner.desktop_images?.map(formatBannerPath),
            mobile_images: data.banner.mobile_images?.map(formatBannerPath),
          };

          setPageData({ ...data, banner: processedBanner });
        }
      } catch (err) {
        console.error("Error fetching Care Konnect data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const collapseElements = document.querySelectorAll('#careKonnectAccordion .collapse');

    const handleShow = function () {
      const header = document.querySelector(`[data-bs-target="#${this.id}"]`);
      if (header) {
        header.querySelector('.arrow-icon')?.classList.add('rotated');
        const title = header.querySelector('span');
        title?.classList.add('expanded-text');
        title?.classList.remove('truncate-text-approval');
      }
    };

    const handleHide = function () {
      const header = document.querySelector(`[data-bs-target="#${this.id}"]`);
      if (header) {
        header.querySelector('.arrow-icon')?.classList.remove('rotated');
        const title = header.querySelector('span');
        title?.classList.add('truncate-text-approval');
        title?.classList.remove('expanded-text');
      }
    };

    collapseElements.forEach((el) => {
      el.addEventListener('shown.bs.collapse', handleShow);
      el.addEventListener('hidden.bs.collapse', handleHide);
    });

    return () => {
      collapseElements.forEach((el) => {
        el.removeEventListener('shown.bs.collapse', handleShow);
        el.removeEventListener('hidden.bs.collapse', handleHide);
      });
    };
  }, [pageData]);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!pageData) return null;

  const { banner, content } = pageData;

  return (
    <>
      <DynamicBanner
        title={banner.title}
        bgImage={banner.desktop_images}
        bgImageMobile={banner.mobile_images}
      />

      <section className="pb_80  ">
        <div className="container">
          <section className="mb-5">

            <div className="row">
              <div className="col-12">
                <div className="sec-title text-center">
                  <h2>{content.heading || "CARE E-Newsletter"}</h2>
                </div>
              </div>
            </div>

            <div className="row g-4 accordion" id="careKonnectAccordion">
              {content.items?.length > 0 ? (
                content.items.map((item, index) => {
                  const uniqueId = `care_konnect_item_${item.id}`;
                  return (
                    <DocCard
                      key={uniqueId}
                      id={uniqueId}
                      title={item.title}
                      files={item.files}
                      colorIndex={index}
                    />
                  );
                })
              ) : (
                <div className="col-12 text-center text-muted">
                  No newsletters found.
                </div>
              )}
            </div>

          </section>
        </div>
      </section>
    </>
  );
};

export default CareKonnect;
